import { createSelector } from '@ngrx/store';
import { getOtc3State } from './appState';
// import { OTC3Order } from 'src/app/global';
export interface Otc3State {
  readonly userOrders: Array<any>;
  readonly marketOrders: Array<any>;
  readonly isFetchingOrders: boolean;
  readonly isTxPending: boolean;
  readonly pendingOrderId: number;
  readonly message: string;
}

export const getOtc3UserOrders = createSelector(getOtc3State, (state: Otc3State) => state.userOrders);
export const getOtc3MarketOrders = createSelector(getOtc3State, (state: Otc3State) => state.marketOrders);
export const getOtc3OrdersFetchingState = createSelector(getOtc3State, (state: Otc3State) => state.isFetchingOrders);
export const getOtc3TxPendingState = createSelector(getOtc3State, (state: Otc3State) => state.isTxPending);
export const getOtc3PendingOrderId = createSelector(getOtc3State, (state: Otc3State) => state.pendingOrderId);
export const getOtc3StatusMessage = createSelector(getOtc3State, (state: Otc3State) => state.message);
